import React from 'react'
import { Modal } from 'react-bootstrap'
import { FaSpinner } from 'react-icons/fa'
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

const SearchModelAdmin = (props) => {
    const currentDate = new Date();
    const UserOption = [
        { name: 'Retargettingads', code: 'Retargettingads' },

    ];
    return (
        <>
            <Modal className="theme-modal" show={props.show} onHide={props.handleClose} backdrop="static" centered>
                <Modal.Header className='pb-0' closeButton style={{ borderBottom: "0" }}></Modal.Header>
                <Modal.Body className='pt-3'>
                    <div className="submit_modal">
                        <div className="modal-card link_submit_modal mt-2 pt-2">
                            <form>
                                <div className='creator_new_task h-100'>
                                    <div className='account-block w-100 p-0 mb-2'>
                                        <div className='submission_wrap submission_bg mt-3 mb-2 w-100 phone-emails' style={{ height: "70px" }}>

                                            <lable className="mb-2">Name</lable>
                                            <input className='form-control border-0' placeholder="Enter Your Name"
                                                type="text"
                                                name="name"
                                                onChange={props.handleSearchChange}
                                                value={props.searchData.name}
                                            />

                                        </div>
                                        <div className='submission_wrap submission_bg mt-3 mb-2 w-100 phone-emails' style={{ height: "70px" }}>

                                            <lable className="mb-2">Email</lable>
                                            <input className='form-control border-0'
                                                placeholder="Enter Your Email"
                                                type="email"
                                                name="email"
                                                onChange={props.handleSearchChange}
                                                value={props.searchData.email}
                                            />

                                        </div>
                                        <div className='submission_wrap submission_bg mt-3 mb-2 w-100 phone-emails' style={{ height: "70px" }}>

                                            <lable className="mb-2">Mobile Number</lable>
                                            <input className='form-control border-0' placeholder="Enter Your Mobile"
                                                type="number"
                                                name="mobileNumber"
                                                onChange={props.handleSearchChange}
                                                value={props.searchData.mobileNumber}
                                                onKeyDown={(e) => {
                                                    if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                        e.preventDefault();
                                                    }
                                                }}

                                            />
                                        </div>
                                        <div className='submission_wrap submission_bg mt-3 flex-row w-100 justify-content-start gap-2'>
                                            <div className='d-flex align-items-center'> <h6 style={{ fontWeight: "500", marginRight: "8px" }}>From</h6>
                                                <div className="date-pickers p-0 flex justify-content-center">
                                                    <Calendar value={props.startDate} onChange={(e) => props.setStartDate(e.value)} maxDate={props.endDate || currentDate} dateFormat="dd/mm/yy" />
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center'> <h6 style={{ fontWeight: "500", marginRight: "10px" }}>To</h6>
                                                <div className="date-pickers p-0 flex justify-content-center">
                                                    <Calendar value={props.endDate} onChange={(e) => props.setEndDate(e.value)} minDate={props.startDate} maxDate={currentDate} dateFormat="dd/mm/yy" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='submission_wrap submission_bg mt-3 w-100'>
                                            <lable className="mb-2">Select user type</lable>
                                            <Dropdown style={{ padding: "4px 10px", marginTop: "1px" }} value={props.userType} onChange={(e) => props.setUserType(e.value)} options={UserOption} optionLabel="name"
                                                placeholder="Select a user type" className="rounded-2 border-0" />
                                        </div>
                                    </div>
                                </div>
                                <div className="application_btn text-center mt-2 d-flex justify-content-end">
                                    <button className="theme-btn" type="button" onClick={props.handleSubmitSearch}>Search {props.loader.search ? <FaSpinner className="spin ms-1" /> : null}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default SearchModelAdmin